"use client";

/**
 * Thin wrapper kept so `app/layout.tsx` stays stable.
 * Top navigation progress bar was removed in favor of per-route skeleton overlays
 * (`MainContentPendingOverlay` + `LinkPendingNotifier`).
 */
export default function LoadingProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <>{children}</>;
}
